import { FormDetailsTranslations } from './types';

export const deTranslations: FormDetailsTranslations = {
    classNameLabel: "Session-Name (Pflichtfeld):",
    patientCountLabel: "Patientenzahl zu Beginn:",
    arrivalIntervalLabel: "Patientenankunftsintervall-:",
    classNamePlaceholder: "z.B. Einführungskurs"
};